import React from 'react';
import 'react-perfect-scrollbar/dist/css/styles.css';
// // import './assets/styles/style.css';
import Router from './routes/AppRoutes';
import GlobalToast from './components/common/GlobalToast';

function App() {
  return (
    <div data-theme="light">
      <GlobalToast />
      <Router />
    </div>
  );
}

export default App;
